import { Box } from "@jewlr/storybook/core"

import { Section, SectionTitle, Text } from "@jewlr/storybook/info"
import { jewlr_t } from "helpers/application"

const SketchFab = () => (
  <Box mb={7}>
    <Section>
      <Box contain>
        <SectionTitle>
          Sketchfab Disrupts Traditional Banner Advertising
        </SectionTitle>
        <Text>
          <small>
            Originally published 2017/05/11 at{" "}
            <a
              href="https://www.prweb.com/releases/2017/05/prweb14324348.htm"
              rel="noopener noreferrer"
              target="_blank"
            >
              prweb.com
            </a>
            .{" "}
          </small>
        </Text>
        <Text>
          JEWLR, a progressive {jewlr_t("terms.jewelry")}ry e-commerce shop, is
          using Sketchfab, the world&apos;s largest platform to publish, share
          and discover 3D content online to disrupt the world of traditional
          banner advertisements.
        </Text>

        <Text>
          <a
            href="https://sketchfab.com/"
            rel="noopener noreferrer"
            target="_blank"
          >
            sketchfab.com
          </a>{" "}
          releases a 3D advertising case study and pilot program.
        </Text>

        <Text>
          One of Sketchfab&apos;s main goals has been to push the boundaries of
          3D/VR, and we are constantly searching for innovative and disruptive
          applications for our technology. Recently, in partnership with JEWLR,
          an innovative online {jewlr_t("terms.jewelry")}ry marketplace,
          Sketchfab has enabled the use of their 3D viewer in a series of banner
          advertisements.
        </Text>

        <Text>
          This partnership proved to be a massive success, delivering a 147.66%
          ROAS (return on ad spend), a major increase over JEWLR&apos;s
          traditional banner advertising efforts, as well as improving the
          quality of their advertising traffic by decreasing their bounce rates
          by up to 53.38%.
        </Text>

        <Text>
          To summarize these efforts and provide advertisers with a chance to
          test this disruptive technology, Sketchfab has released a case study
          along with a pilot program.
        </Text>

        <Text>
          To see the case study and sign up for our pilot program visit:
          <br />
          <a
            href="https://blog.sketchfab.com/3d-advertising-case-study-jewlr/"
            rel="noopener noreferrer"
            target="_blank"
          >
            https://blog.sketchfab.com/3d-advertising-case-study-jewlr/
          </a>
        </Text>
      </Box>
    </Section>
  </Box>
)

export default SketchFab
